import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { RouteConfig } from 'vue-router'
import { asyncRoutes, constantRoutes } from '@/router'
import store from '@/store'


// 判断用户权限
const hasPermission = (role: string, route: RouteConfig) => {
  if (route.meta && route.meta.roles) {
    // console.log(route.meta)
    return route.meta.roles.indexOf(role) !== -1;
  } else {
    return true
  }
}
// 筛选异步路由
const filterAsyncRoutes = (routes: RouteConfig[], role: string) => {
  const res: RouteConfig[] = []
  routes.forEach(route => {
    const r = { ...route }
    if (hasPermission(role, r)) {
      r.children && filterAsyncRoutes(r.children,role)
      res.push(r)
    }
  })
  return res
}

export interface PermissionState {
  allRoutes: RouteConfig[]
  dynamicRoutes: RouteConfig[]
}

@Module({ dynamic: true, store, name: 'permission' })
class Permission extends VuexModule implements PermissionState {
  public dynamicRoutes: RouteConfig[] = []
  public allRoutes: RouteConfig[] = []

  @Mutation
  private SET_ROUTES(routes: RouteConfig[]) {
    this.allRoutes = constantRoutes.concat(routes);
    this.dynamicRoutes = routes;
  }

  @Action
  public setRoutes(role: string) {
    const ContractType:any = window.localStorage.getItem('ContractType')
    let accessedRoutes = filterAsyncRoutes(asyncRoutes, role).map(v=>{
      if(v.path == '/finance'){
        v.children = v.children.filter(x=>{
          if(ContractType==1){
            return true
          }else{
            return x.name!='invoice'
          }
        })
      }
      return v
    })
    this.SET_ROUTES(accessedRoutes);
  }
}

export const PermissionModule = getModule(Permission)